import React from 'react';
import CustomAvailableItems from '../../../../../components/CustomAvailableAssignedItems/CustomAvailableItems';
import CustomAssignedItems from '../../../../../components/CustomAvailableAssignedItems/CustomAssignedItems';
import {
    IconDocumentLinedGrid,
    PlusIconsOptions,
    TrashOutlineIcon,
} from '../../../../../components/buttons/IconButtons';
import { SEARCH_MODEL } from '../../../../../components/table/Model/TableModel';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomTabContainer from '../../../../../components/CustomTabContainer';
import CustomTab from '../../../../../components/CustomTab';
import { EMPLOYEE_TAB } from '../Model/AllowedModules';
import {
    getAllroleEmployeesPageable,
} from '../../../../../reduxToolkit/EmployeeRoles/EmployeeRolesApi';
import { useSelector } from 'react-redux';
import { SimpleSearch } from '../../../../../reduxToolkit/Search/SearchApi';
import { TABLES } from '../../../../../Apis/Tables';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import DeleteModal from '../../../../Modals/DeleteModal';
import { permissionObj } from '../../../../../Helpers/permission';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */
const AssignedEmployeesUpdate = ({
    id,
    selected,
    setSelected,
    handleClearEmployees,
    initialUsers,
    setInitialUsers,
    handleDeleteUsers,
    modified,
    setModified,
}) => {
    const { t } = useTranslation();
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    // Assigning employees to the role requires the manage users permission
    const canManageUsers = DEV || permission?.includes(permissionObj?.WEB_PRIVILEGE_MANAGE_USERS);
    const tabs = Object.values(EMPLOYEE_TAB).filter(
        (item) => canManageUsers || item.key !== EMPLOYEE_TAB.ADD_EMPLOYEES.key,
    );

    const [subViewChild, setSubViewChild] = useState(
        canManageUsers ? EMPLOYEE_TAB.ADD_EMPLOYEES.key : EMPLOYEE_TAB.ASSIGNED_EMPLOYEES.key,
    );

    const [results, setResults] = useState({
        content: [],
        totalElements: 0,
    });
    const [searchElement, setSearchElement] = useState('');
    const [search, setSearch] = useState(false);
    const [simpleSearch, setSimpleSearch] = useState(false);

    const [isAllChecked, setIsAllChecked] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);

    const handleSetResults = (data) => {
        setResults(data);
    };

    return (
        <>
            <div className='border-full-shades-200 col-12 border-radius-8px px-0'>
                <CustomTabContainer
                    activeTab={subViewChild}
                    setActiveTab={(tab) => {
                        setSearchElement('');
                        setResults({
                            content: [],
                            totalElements: 0,
                        });
                        setSubViewChild(tab);
                    }}
                    className='border-0 px-3'
                    buttonAction={
                        subViewChild === EMPLOYEE_TAB.ASSIGNED_EMPLOYEES.key && canManageUsers && (
                            <ButtonAction
                                id='btn_a_delete'
                                name='delete'
                                className='btn-icon-delete h-100'
                                Icon={TrashOutlineIcon}
                                onClick={() => setDeleteModal(true)}
                                disabled={!initialUsers?.length}
                            />
                        )
                    }
                >
                    {tabs.map((item) => (
                        <CustomTab
                            key={item.key}
                            id={item.key}
                            title={t(item.translation)}
                            icon={item.icon}
                            selected={subViewChild === item.key}
                            onClick={() => setSubViewChild(item.key)}
                        />
                    ))}
                </CustomTabContainer>
                <div className='border-bottom-shades-300 mb-3' />
                {subViewChild === EMPLOYEE_TAB.ADD_EMPLOYEES.key && canManageUsers && (
                    <CustomAvailableItems
                        results={results}
                        setResults={setResults}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        setSearch={setSearch}
                        setSimpleSearch={setSimpleSearch}
                        modified={modified}
                        setModified={setModified}
                        selected={selected}
                        setSelected={setSelected}
                        keyId={'userId'}
                        tableTitle={true}
                        tableIconTitle={<IconDocumentLinedGrid />}
                        selectedSectionIconTitle={<PlusIconsOptions />}
                        labelRowsPerPage={'employees_per_page'}
                        tableNotInformationLegend={'you_havent_created_any_employees_yet'}
                        selectedSectionNotInformationLegend={'no_employees_added_yet'}
                        tableEndPoint={(body) => SimpleSearch({ body })}
                        tableBuildBody={({ page, rowsPerPage, searchElement }) =>
                            SEARCH_MODEL.setObject({
                                page: page,
                                size: rowsPerPage,
                                key: searchElement,
                                model: TABLES.EMPLOYEES,
                            })
                        }
                        viewTypeName={'employees'}
                    />
                )}
                {subViewChild === EMPLOYEE_TAB.ASSIGNED_EMPLOYEES.key && (
                    <CustomAssignedItems
                        results={results}
                        setResults={handleSetResults}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        setSearch={setSearch}
                        setSimpleSearch={setSimpleSearch}
                        modified={modified}
                        setModified={setModified}
                        selected={initialUsers}
                        setSelected={setInitialUsers}
                        keyId={'userId'}
                        labelRowsPerPage={'employees_per_page'}
                        tableNotInformationLegend={'you_have_not_assigned_any_employee_yet'}
                        tableEndPoint={(body) => getAllroleEmployeesPageable(body)}
                        tableBuildBody={({ page, rowsPerPage, searchElement }) => {
                            const body = SEARCH_MODEL.setObject({
                                page,
                                size: rowsPerPage,
                                key: searchElement,
                                id,
                            });
                            return body;
                        }}
                        viewTypeName={'employees'}
                        isAllChecked={isAllChecked}
                        setIsAllChecked={setIsAllChecked}
                        checkbox={canManageUsers}
                        onDelete={
                            canManageUsers
                                ? (items) => {
                                      const normalized = Array.isArray(items) ? items : items?.userId ? [items] : [];

                                      const ids = normalized.map((u) => u.userId);

                                      setInitialUsers(ids);
                                      setDeleteModal(true);
                                  }
                                : false
                        }
                    />
                )}
            </div>
            <DeleteModal
                show={deleteModal}
                onHide={() => {
                    setDeleteModal(false);
                    setIsAllChecked(false);
                    setInitialUsers([]);
                }}
                data={initialUsers}
                onClickFn={() => {
                    handleDeleteUsers(initialUsers);
                    setDeleteModal(false);
                }}
                title_modal={'delete_employee'}
                element_modal={'employee'}
                isReset={() => setInitialUsers([])}
            />
        </>
    );
};

export default AssignedEmployeesUpdate;
